import { cn } from "@shared/ui";
import { forwardRef, ReactNode, UIEventHandler, useState } from "react";

type StepBodyProps = {
  children: ReactNode;
  className?: string;
  centered?: boolean;
  onScroll?: UIEventHandler<HTMLDivElement>;
  // Screens without a nav (the interstitial) have nothing to divide from.
  scrollDivider?: boolean;
};

// The only scrolling region of a step; the card header and StepFooter stay fixed.
const StepBody = forwardRef<HTMLDivElement, StepBodyProps>(
  ({ children, className, centered, onScroll, scrollDivider = true }, ref) => {
    // A divider under the nav appears only while content is scrolled beneath it.
    const [isScrolled, setIsScrolled] = useState(false);

    return (
      <div
        ref={ref}
        onScroll={(e) => {
          setIsScrolled(e.currentTarget.scrollTop > 0);
          onScroll?.(e);
        }}
        className={cn(
          "flex min-h-0 flex-1 flex-col overflow-y-auto overscroll-contain border-t transition-colors",
          scrollDivider && isScrolled ? "border-subtle" : "border-transparent"
        )}
      >
        <div
          className={cn(
            "flex flex-col gap-8 px-6 pb-6 pt-4",
            // Spacers sit the content a little above the middle.
            centered && "grow before:flex-[2] before:content-[''] after:flex-[3] after:content-['']",
            className
          )}
        >
          {children}
        </div>
      </div>
    );
  }
);

StepBody.displayName = "StepBody";

export default StepBody;
